// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"az_Ju","skinnyRecommendations":"az_Ku"};